export const SET_SELLER = "SET_SELLER";
export const REMOVE_SELLER = "REMOVE_SELLER";
export const NETWORK_ERROR = "NETWORK_ERROR";
export const CLEAR_NETWORK_ERROR = "CLEAR_NETWORK_ERROR";
